// import React, { useEffect, useState } from "react";
// import { GreenContent, JuryRound, RedContent, RedMainHeading } from "../../../../Global/GlobalText";
// import { IoSearchSharp } from "react-icons/io5";
// import { LuFilter } from "react-icons/lu";
// import { useNavigate } from "react-router-dom";
// import "./ShortListEntryForm.scss";
// import { CreateButton, GreyBorderButton, GreyfilterButton, RedBackgroundButton } from "../../../../Global/GlobalButton";
// import { GlobalSecondTable } from "../../../../Global/GlobalSecondTable/GlobalSecondTable";
// import { TitleBar } from "../../../../Global/TitleBar/TitleBar";
// import { TopBar } from "../../../TopBar/TopBar";
// import axios from "axios";
// import { EXCHNAGE_URL } from "../../../../../Url/Url";
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import { MdEditSquare } from "react-icons/md";
// import { useLoading } from "../../../../LoadingContext"; // ✅ ADD THIS

// export const ShortListEntryForm = () => {
//     const { setLoading } = useLoading(); // ✅ ADD THIS - Global loader

//   const [selectedRows, setSelectedRows] = useState([]);
//   const [selectedButton, setSelectedButton] = useState(0);
//   const eventIdGet = useSelector((state) => state?.users?.id);
//   const [selectedRound, setSelectedRound] = useState(null);
//   const [roundData, setRoundData] = useState([]);
//   const [roundId, setRoundId] = useState(null);
//   const [roundName, setRoundName] = useState("");
//   const [isDropdownVisible, setIsDropdownVisible] = useState(false);
//   const [selectedData, setSelectedData] = useState([]);
//   const eventId = String(eventIdGet);
//   const [loader, setLoader] = useState(false)
//   const [selectedSubmissionIds, setSelectedSubmissionIds] = useState([]);
//   const [shortlistedData, setShortlistedData] = useState([])
//   const navigate = useNavigate();
//   const token = localStorage.getItem("token")
//  // ✅ NEW: Search and Filter states
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterType, setFilterType] = useState(""); // "title-asc", "title-desc", "category-asc", "category-desc"
//   const [filteredData, setFilteredData] = useState([]);

//   const getShortlistedData = async () => {
//     setLoader(true)
//         setLoading(true); // ✅ Start global loader

//     try {
//       const apiUrl = `${EXCHNAGE_URL}/getShortlist?eventId=${eventId}&is_shortlist=0`;
//       const response = await axios.get(apiUrl, {
//         headers: {
//           "Content-Type": "Application/json",
//           authorization: `Bearer ${token}`,
//         },
//       });
//       if (response.status === 200) {
//         console.log(response, "sesssss")
//         const subData = response.data.data
//         setShortlistedData(subData);
//                 setFilteredData(subData); // ✅ Set filtered data

//       }
//     } catch (error) {
//       console.log(error)
//     }finally {
//       setLoader(false);
//       setLoading(false); // ✅ Stop global loader
//     }
//   }


//   const updatePaymentStatus = async (submissionId) => {
//         setLoading(true); // ✅ Start global loader

//   try {
//     const response = await axios.put(
//       `${EXCHNAGE_URL}/submission/payment-status`,
//       {
//         submissionId,
//       },
//       {
//         headers: {
//           authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     if (response.data.success) {
//       toast.success("Payment Updated");
//       getShortlistedData();
//     }
//   } catch (error) {
//     toast.error("Failed to update payment");
//   }finally {
//       setLoading(false); // ✅ Stop global loader
//     }
// };
//   useEffect(() => {
//     const fetchRounds = async () => {
//             setLoading(true); // ✅ Start global loader

//       try {
//         const response = await axios.get(`${EXCHNAGE_URL}/listOfRounds?eventId=${eventId}`, {
//           headers: {
//             'Authorization': `Bearer ${token}`,
//             'Content-Type': 'application/json'
//           }
//         });
//         const roundData = response.data.data;
//         setRoundData(roundData);
//       } catch (error) {
//         console.log(error);
//       }finally {
//         setLoading(false); // ✅ Stop global loader
//       }
//     };
//     fetchRounds();
//   }, [eventId, token]);

//   useEffect(() => {
//     getShortlistedData();
//   }, [eventId]);


//   const handleRoundClick = (round) => {
//     setSelectedRound(round);
//     toast.success("Round selected Successfully")
//     setRoundId(round.roundId);
//     setRoundName(round.round_name)
//     setIsDropdownVisible(false);

//   };

//   const handleCheckboxChangeTable = (rowId, checked) => {
//     const selectedRow = shortlistedData.find((row) => row["Submission ID"] === rowId);
//     console.log(selectedRow, "rowwwwww")
//     if (checked) {
//       setSelectedData((prevSelectedData) => [
//         ...prevSelectedData,
//         selectedRow["Submission ID"],
//       ]);
//     } else {
//       setSelectedData((prevSelectedData) =>
//         prevSelectedData.filter((id) => id !== selectedRow["Submission ID"])
//       );
//     }

//     if (checked) {
//       setSelectedRows((prevSelectedRows) => [...prevSelectedRows, rowId]);
//     } else {
//       setSelectedRows((prevSelectedRows) =>
//         prevSelectedRows.filter((id) => id !== rowId)
//       );
//     }
//   };


//   console.log(shortlistedData, "daaaatatatat")
//   const columns = [
//     { label: "Submission ID", accessor: "Submission ID" },
//     { label: "Category", accessor: "Category" },
//     { label: "Title", accessor: "Title" },
//     { label: "Overall Score", accessor: "Overall Score" },
//     { label: "Payment Status", accessor: "Payment Status" },
//   { label: "Action", accessor: "Action" },

//   ];

//   const data = shortlistedData
//     .filter(submission => submission && submission.fields)
//     .map((submission) => {
//       const title = submission.fields.find(field => field.field_name.startsWith("title"))?.field_value || "";
//       const category = submission.fields.find(field => field.field_name.startsWith("category"))?.field_value || "";
//       const paymentStatus = submission.payment_status; // ✅ Extract `paymentstatus` correctly


//       console.log(paymentStatus, "paymentStatus")
//       return {
//         rowId: submission.submission_id,
//         "Submission ID": submission.submission_id,
//         Category: category,
//         Title: title,
//         "Overall Score": submission.score !== null ? submission.score : "",
//         "Payment Status": paymentStatus, // ✅ Corrected
//       Action:
//   paymentStatus?.toLowerCase() !== "paid" ? (
//     <button
//       onClick={() => updatePaymentStatus(submission.submission_id)}
//       style={{
//         background: "#16a34a",
//         color: "#fff",
//         border: "none",
//         padding: "8px 14px",
//         borderRadius: "8px",
//         cursor: "pointer",
//         fontWeight: "600",
//         fontSize: "13px",
//         transition: "0.3s",
//       }}
//     >
//       ✓ Mark as Paid
//     </button>
//   ) : (
//     <span
//       style={{
//         background: "#dcfce7",
//         color: "#15803d",
//         padding: "8px 14px",
//         borderRadius: "8px",
//         fontWeight: "600",
//         display: "inline-block",
//       }}
//     >
//       ✓ Paid
//     </span>
//   ),
//       };
//     });

//   console.log(data, "daadadaada")




//   const handleCheckboxChange = (rowId, checked) => {
//     const selectedRow = shortlistedData.find((row) => row["Submission ID"] === rowId);

//     if (checked) {
//       setSelectedData((prevSelectedData) => [...prevSelectedData, rowId]);
//     } else {
//       setSelectedData((prevSelectedData) =>
//         prevSelectedData.filter((id) => id !== rowId)
//       );
//     }

//     if (checked) {
//       setSelectedRows((prevSelectedRows) => [...prevSelectedRows, rowId]);
//     } else {
//       setSelectedRows((prevSelectedRows) =>
//         prevSelectedRows.filter((id) => id !== rowId)
//       );
//     }
//   };


//   const setSelectedRow = (row) => {
//     console.log("Selected row:", row);
//   };


//   const handleClick = (index) => {
//     setSelectedButton(index);

//     if (index === 0) {
//       // Select all rows
//       setSelectedRows(data.map((row) => row.rowId));
//     } else {
//       // Deselect all rows
//       setSelectedRows([]);
//     }
//   };

//   const handleSubmit = async () => {
//     if(!roundId){
//       toast.error("Please Select a round.")
//     }
//     if (selectedData.length === 0) {
//       toast.error('Please select at least one submission.');
//       return;
//     }
//     setLoading(true); // ✅ Start global loader

//     try {
//       const payload = {
//         eventId: eventId,
//         roundId: roundId,
//         submission_ids: selectedData,
//         shortlist_round: roundName,
//       };

//       const response = await axios.post(`${EXCHNAGE_URL}/shortlist`, payload, {
//         headers: {
//           "Content-Type": "application/json",
//           authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       });

//       if (response.status === 200) {
//         toast.success('Shortlist submitted successfully');
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error('Error submitting shortlist');
//     }finally {
//       setLoading(false); // ✅ Stop global loader
//     }
//   };


//   return (
//     <div>
//       <div className="shortlistentry_data_div">
//         <TitleBar title="Jury Round" />
//         <div className="shortlistentry_data_white_bg">
//           <TopBar titleheading="Shortlist Entry Form for Round 1" />
//         <div className="newBtn">
        
//                       <div>
//                         <button
//                           className="Bt"
//                         onClick={() => setIsDropdownVisible(!isDropdownVisible)}>
//                           {isDropdownVisible ? 'Hide Rounds' : 'Show Rounds'}
//                         </button>
        
//                         {isDropdownVisible && (
//                           <div
//                           className={`dropdown-container ${isDropdownVisible ? "show" : ""}`}
//                           >
//                             {roundData.length !== 0 ? (
//                               roundData.map((round, index) => (
//                                 <div
//                                   key={round.roundId}
//                                   className="round-button-container"
//                                   style={{ marginBottom: '1rem' }}
//                                 >
//                                   <CreateButton className="Btt" onClick={() => handleRoundClick(round)}>
//                                     {round.round_name}
//                                   </CreateButton>
//          {round.is_active === 1 ? (
//                 <GreenContent>Active</GreenContent>
//               ) : (
//                 <RedContent>Unactive</RedContent>
//               )}                        </div>
//                               ))
//                             ) : (
//                               <div>No rounds available</div>
//                             )}
//                           </div>
//                         )}
//                       </div>
        
//                       {selectedRound && (
//                         <div className="round-details">
//                           <CreateButton>
//                             {selectedRound.round_name}
//                           </CreateButton>
//                           {/* <GreenContent>Active</GreenContent> */}
//                         </div>
//                       )}
//                     </div>
//           <div className="shortlistentry_submission_div">
//             <div
//               className="shortlistentry_sub_submission"
//               style={{ backgroundColor: selectedButton === 0 ? "#FFE2E5" : "#F6F8F9" }}
//               onClick={() => {
//                 handleClick(0);
//                 setSelectedRows(data.map(row => row.rowId)); // Select all rows
//                 setSelectedData(data.map(row => row.rowId))
//               }}
//             >
//               <RedMainHeading>Viewing: {data.length} submissions</RedMainHeading>
//               <JuryRound>Select all submissions</JuryRound>
//             </div>
//             <div
//               className="shortlistentry_sub_submission"
//               style={{ backgroundColor: selectedButton === 1 ? "#FFE2E5" : "#F6F8F9" }}
//               onClick={() => {
//                 handleClick(1);
//                 setSelectedRows([]); // Deselect all rows
//                 setSelectedData([])
                
//               }}
//             >
//               <RedMainHeading>Selected: {selectedRows.length} submissions</RedMainHeading>
//               <JuryRound>Deselect all selected submissions</JuryRound>
//             </div>
//           </div>

//           <div className="shortlistentry__table_div">
//             <div className="shortlistentry__table_search">
//               <div className="shortlistentry__table_icon">
//                 <IoSearchSharp />
//               </div>
//               <div className="shortlistentry__table_icon_content">
//                 <input
//                   type="text"
//                   placeholder="Start typying  to filter grid"
//                 />
//               </div>
//             </div>

//             <GreyfilterButton className="shortlistentry__filter_icon">
//               <LuFilter />
//               Filter
//             </GreyfilterButton>
//           </div>

//           {selectedButton === 0 && (
//             <>
//               <GlobalSecondTable
//                 data={data}
//                 columns={columns}
//                 selectedRows={selectedRows}
//                 onCheckboxChange={handleCheckboxChange}
//                 onRowClick={setSelectedRow}

//               />
//             </>
//           )}

//           {selectedButton === 1 && (
//             <>
//               <GlobalSecondTable
//                 data={data}
//                 columns={columns}
//                 selectedRows={selectedRows} // Ensure this is always an array
//                 onCheckboxChange={handleCheckboxChange}
//                 onRowClick={setSelectedRow}
//               />
//             </>
//           )}

//           <div className="shortlist_butt">
//             <GreyBorderButton
//               onClick={() => {
//                 navigate("/jury-round");
//               }}
//             >
//               Back to Jury Rounds
//             </GreyBorderButton>

//             <RedBackgroundButton
//               onClick={handleSubmit}
//             >
//               Shortlist Selected Entry Form
//             </RedBackgroundButton>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };


// import React, { useEffect, useState } from "react";
// import { GreenContent, JuryRound, RedContent, RedMainHeading } from "../../../../Global/GlobalText";
// import { IoSearchSharp } from "react-icons/io5";
// import { LuFilter } from "react-icons/lu";
// import { useNavigate } from "react-router-dom";
// import "./ShortListEntryForm.scss";
// import { CreateButton, GreyBorderButton, GreyfilterButton, RedBackgroundButton, ViewMoreButton } from "../../../../Global/GlobalButton";
// import { GlobalSecondTable } from "../../../../Global/GlobalSecondTable/GlobalSecondTable";
// import { TitleBar } from "../../../../Global/TitleBar/TitleBar";
// import { TopBar } from "../../../TopBar/TopBar";
// import axios from "axios";
// import { EXCHNAGE_URL } from "../../../../../Url/Url";
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import { MdEditSquare } from "react-icons/md";
// import { useLoading } from "../../../../LoadingContext";

// export const ShortListEntryForm = () => {
//   const { setLoading } = useLoading();

//   const [selectedRows, setSelectedRows] = useState([]);
//   const [selectedButton, setSelectedButton] = useState(0);
//   const eventIdGet = useSelector((state) => state?.users?.id);
//   const [selectedRound, setSelectedRound] = useState(null);
//   const [roundData, setRoundData] = useState([]);
//   const [roundId, setRoundId] = useState(null);
//   const [roundName, setRoundName] = useState("");
//   const [isDropdownVisible, setIsDropdownVisible] = useState(false);
//   const [selectedData, setSelectedData] = useState([]);
//   const eventId = String(eventIdGet);
//   const [loader, setLoader] = useState(false);
//   const [selectedSubmissionIds, setSelectedSubmissionIds] = useState([]);
//   const [shortlistedData, setShortlistedData] = useState([]);
  
//   // ✅ NEW: Search and Filter states
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterType, setFilterType] = useState(""); // "title-asc", "title-desc", "category-asc", "category-desc"
//   const [filteredData, setFilteredData] = useState([]);

//   const navigate = useNavigate();
//   const token = localStorage.getItem("token");

//   const getShortlistedData = async () => {
//     setLoader(true);
//     setLoading(true);
//     try {
//       const apiUrl = `${EXCHNAGE_URL}/getShortlist?eventId=${eventId}&is_shortlist=0`;
//       const response = await axios.get(apiUrl, {
//         headers: {
//           "Content-Type": "Application/json",
//           authorization: `Bearer ${token}`,
//         },
//       });
//       if (response.status === 200) {
//         console.log(response, "sesssss");
//         const subData = response.data.data;
//         setShortlistedData(subData);
//         setFilteredData(subData); // ✅ Set filtered data
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoader(false);
//       setLoading(false);
//     }
//   };

//   const updatePaymentStatus = async (submissionId) => {
//     setLoading(true);
//     try {
//       const response = await axios.put(
//         `${EXCHNAGE_URL}/submission/payment-status`,
//         { submissionId },
//         {
//           headers: { authorization: `Bearer ${token}` },
//         }
//       );
//       if (response.data.success) {
//         toast.success("Payment Updated");
//         getShortlistedData();
//       }
//     } catch (error) {
//       toast.error("Failed to update payment");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const fetchRounds = async () => {
//       setLoading(true);
//       try {
//         const response = await axios.get(`${EXCHNAGE_URL}/listOfRounds?eventId=${eventId}`, {
//           headers: {
//             'Authorization': `Bearer ${token}`,
//             'Content-Type': 'application/json'
//           }
//         });
//         const roundData = response.data.data;
//         setRoundData(roundData);
//       } catch (error) {
//         console.log(error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchRounds();
//   }, [eventId, token]);

//   useEffect(() => {
//     getShortlistedData();
//   }, [eventId]);

//   // ✅ NEW: Filter and Search logic
//   useEffect(() => {
//     let result = [...shortlistedData];

//     // 1. Apply Search
//     if (searchTerm.trim() !== "") {
//       const searchLower = searchTerm.toLowerCase().trim();
//       result = result.filter((submission) => {
//         const title = submission.fields.find(field => field.field_name.startsWith("title"))?.field_value || "";
//         const category = submission.fields.find(field => field.field_name.startsWith("category"))?.field_value || "";
//         const submissionId = String(submission.submission_id || "");
        
//         return (
//           title.toLowerCase().includes(searchLower) ||
//           category.toLowerCase().includes(searchLower) ||
//           submissionId.includes(searchLower)
//         );
//       });
//     }

//     // 2. Apply Filter/Sort
//     if (filterType) {
//       result = [...result].sort((a, b) => {
//         const getTitle = (item) => item.fields.find(field => field.field_name.startsWith("title"))?.field_value || "";
//         const getCategory = (item) => item.fields.find(field => field.field_name.startsWith("category"))?.field_value || "";

//         let aValue, bValue;
//         switch (filterType) {
//           case "title-asc":
//             aValue = getTitle(a).toLowerCase();
//             bValue = getTitle(b).toLowerCase();
//             return aValue.localeCompare(bValue);
//           case "title-desc":
//             aValue = getTitle(a).toLowerCase();
//             bValue = getTitle(b).toLowerCase();
//             return bValue.localeCompare(aValue);
//           case "category-asc":
//             aValue = getCategory(a).toLowerCase();
//             bValue = getCategory(b).toLowerCase();
//             return aValue.localeCompare(bValue);
//           case "category-desc":
//             aValue = getCategory(a).toLowerCase();
//             bValue = getCategory(b).toLowerCase();
//             return bValue.localeCompare(aValue);
//           default:
//             return 0;
//         }
//       });
//     }

//     setFilteredData(result);
//   }, [searchTerm, filterType, shortlistedData]);

//   const handleRoundClick = (round) => {
//     setSelectedRound(round);
//     toast.success("Round selected Successfully");
//     setRoundId(round.roundId);
//     setRoundName(round.round_name);
//     setIsDropdownVisible(false);
//   };

//   const handleCheckboxChangeTable = (rowId, checked) => {
//     const selectedRow = filteredData.find((row) => row["Submission ID"] === rowId);
//     console.log(selectedRow, "rowwwwww");
//     if (checked) {
//       setSelectedData((prevSelectedData) => [
//         ...prevSelectedData,
//         selectedRow["Submission ID"],
//       ]);
//     } else {
//       setSelectedData((prevSelectedData) =>
//         prevSelectedData.filter((id) => id !== selectedRow["Submission ID"])
//       );
//     }

//     if (checked) {
//       setSelectedRows((prevSelectedRows) => [...prevSelectedRows, rowId]);
//     } else {
//       setSelectedRows((prevSelectedRows) =>
//         prevSelectedRows.filter((id) => id !== rowId)
//       );
//     }
//   };

//   console.log(shortlistedData, "daaaatatatat");
  
//   const columns = [
//     { label: "Submission ID", accessor: "Submission ID" },
//     { label: "Category", accessor: "Category" },
//     { label: "Title", accessor: "Title" },
//     { label: "Overall Score", accessor: "Overall Score" },
//     { label: "Payment Status", accessor: "Payment Status" },
//     { label: "Action", accessor: "Action" },
//   ];

//   const data = filteredData
//     .filter(submission => submission && submission.fields)
//     .map((submission) => {
//       const title = submission.fields.find(field => field.field_name.startsWith("title"))?.field_value || "";
//       const category = submission.fields.find(field => field.field_name.startsWith("category"))?.field_value || "";
//       const paymentStatus = submission.payment_status;

//       console.log(paymentStatus, "paymentStatus");
//       return {
//         rowId: submission.submission_id,
//         "Submission ID": submission.submission_id,
//         Category: category,
//         Title: title,
//         "Overall Score": submission.score !== null ? submission.score : "",
//         "Payment Status": paymentStatus,
//         Action: paymentStatus?.toLowerCase() !== "paid" ? (
//           <button
//             onClick={() => updatePaymentStatus(submission.submission_id)}
//             style={{
//               background: "#16a34a",
//               color: "#fff",
//               border: "none",
//               padding: "8px 14px",
//               borderRadius: "8px",
//               cursor: "pointer",
//               fontWeight: "600",
//               fontSize: "13px",
//               transition: "0.3s",
//             }}
//           >
//             ✓ Mark as Paid
//           </button>
//         ) : (
//           <span
//             style={{
//               background: "#dcfce7",
//               color: "#15803d",
//               padding: "8px 14px",
//               borderRadius: "8px",
//               fontWeight: "600",
//               display: "inline-block",
//             }}
//           >
//             ✓ Paid
//           </span>
//         ),
//       };
//     });

//   console.log(data, "daadadaada");

//   const handleCheckboxChange = (rowId, checked) => {
//     const selectedRow = filteredData.find((row) => row["Submission ID"] === rowId);

//     if (checked) {
//       setSelectedData((prevSelectedData) => [...prevSelectedData, rowId]);
//     } else {
//       setSelectedData((prevSelectedData) =>
//         prevSelectedData.filter((id) => id !== rowId)
//       );
//     }

//     if (checked) {
//       setSelectedRows((prevSelectedRows) => [...prevSelectedRows, rowId]);
//     } else {
//       setSelectedRows((prevSelectedRows) =>
//         prevSelectedRows.filter((id) => id !== rowId)
//       );
//     }
//   };

//   const setSelectedRow = (row) => {
//     console.log("Selected row:", row);
//   };

//   const handleClick = (index) => {
//     setSelectedButton(index);
//     if (index === 0) {
//       setSelectedRows(data.map((row) => row.rowId));
//     } else {
//       setSelectedRows([]);
//     }
//   };

//   const handleSubmit = async () => {
//     if (!roundId) {
//       toast.error("Please Select a round.");
//       return;
//     }
//     if (selectedData.length === 0) {
//       toast.error('Please select at least one submission.');
//       return;
//     }
//     setLoading(true);
//     try {
//       const payload = {
//         eventId: eventId,
//         roundId: roundId,
//         submission_ids: selectedData,
//         shortlist_round: roundName,
//       };

//       const response = await axios.post(`${EXCHNAGE_URL}/shortlist`, payload, {
//         headers: {
//           "Content-Type": "application/json",
//           authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       });

//       if (response.status === 200) {
//         toast.success('Shortlist submitted successfully');
//         getShortlistedData(); // Refresh data
//         setSelectedRows([]);
//         setSelectedData([]);
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error('Error submitting shortlist');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ NEW: Filter button handlers
//   const handleFilterClick = (type) => {
//     if (filterType === type) {
//       setFilterType(""); // Toggle off if same filter clicked
//     } else {
//       setFilterType(type);
//     }
//   };

//   // ✅ NEW: Clear all filters
//   const clearFilters = () => {
//     setSearchTerm("");
//     setFilterType("");
//   };

//   return (
//     <div>
//       <div className="shortlistentry_data_div">
//         <TitleBar title="Jury Round" />
//         <div className="shortlistentry_data_white_bg">
//           <TopBar titleheading="Shortlist Entry Form for Round 1" />
//           <div className="newBtn">
//             <div>
//               <button className="Bt" onClick={() => setIsDropdownVisible(!isDropdownVisible)}>
//                 {isDropdownVisible ? 'Hide Rounds' : 'Show Rounds'}
//               </button>
//               {isDropdownVisible && (
//                 <div className={`dropdown-container ${isDropdownVisible ? "show" : ""}`}>
//                   {roundData.length !== 0 ? (
//                     roundData.map((round, index) => (
//                       <div key={round.roundId} className="round-button-container" style={{ marginBottom: '1rem' }}>
//                         <CreateButton className="Btt" onClick={() => handleRoundClick(round)}>
//                           {round.round_name}
//                         </CreateButton>
//                         {round.is_active === 1 ? (
//                           <GreenContent>Active</GreenContent>
//                         ) : (
//                           <RedContent>Unactive</RedContent>
//                         )}
//                       </div>
//                     ))
//                   ) : (
//                     <div>No rounds available</div>
//                   )}
//                 </div>
//               )}
//             </div>
//             {selectedRound && (
//               <div className="round-details">
//                 <CreateButton>{selectedRound.round_name}</CreateButton>
//               </div>
//             )}
//           </div>

//           <div className="shortlistentry_submission_div">
//             <div
//               className="shortlistentry_sub_submission"
//               style={{ backgroundColor: selectedButton === 0 ? "#FFE2E5" : "#F6F8F9" }}
//               onClick={() => {
//                 handleClick(0);
//                 setSelectedRows(data.map(row => row.rowId));
//                 setSelectedData(data.map(row => row.rowId));
//               }}
//             >
//               <RedMainHeading>Viewing: {data.length} submissions</RedMainHeading>
//               <JuryRound>Select all submissions</JuryRound>
//             </div>
//             <div
//               className="shortlistentry_sub_submission"
//               style={{ backgroundColor: selectedButton === 1 ? "#FFE2E5" : "#F6F8F9" }}
//               onClick={() => {
//                 handleClick(1);
//                 setSelectedRows([]);
//                 setSelectedData([]);
//               }}
//             >
//               <RedMainHeading>Selected: {selectedRows.length} submissions</RedMainHeading>
//               <JuryRound>Deselect all selected submissions</JuryRound>
//             </div>
//           </div>

//           {/* ✅ UPDATED: Search + Filter Buttons */}
//           <div className="shortlistentry__table_div">
//             <div className="shortlistentry__table_search">
//               <div className="shortlistentry__table_icon">
//                 <IoSearchSharp />
//               </div>
//               <div className="shortlistentry__table_icon_content">
//                 <input
//                   type="text"
//                   placeholder="Search by Title, Category or Submission ID..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//               </div>
//             </div>

//             <div className="shortlistentry__filter_buttons">
//               {/* Title Sort Buttons */}
//               <ViewMoreButton
//                 className={`filter-btn ${filterType === "title-asc" ? "active" : ""}`}
//                 onClick={() => handleFilterClick("title-asc")}
//                 title="Sort Title A-Z"
//               >
//                 Title ↑
//               </ViewMoreButton>
//               <ViewMoreButton
//                 className={`filter-btn ${filterType === "title-desc" ? "active" : ""}`}
//                 onClick={() => handleFilterClick("title-desc")}
//                 title="Sort Title Z-A"
//               >
//                 Title ↓
//               </ViewMoreButton>

//               {/* Category Sort Buttons */}
//               <ViewMoreButton
//                 className={`filter-btn ${filterType === "category-asc" ? "active" : ""}`}
//                 onClick={() => handleFilterClick("category-asc")}
//                 title="Sort Category A-Z"
//               >
//                 Category ↑
//               </ViewMoreButton>
//               <ViewMoreButton
//                 className={`filter-btn ${filterType === "category-desc" ? "active" : ""}`}
//                 onClick={() => handleFilterClick("category-desc")}
//                 title="Sort Category Z-A"
//               >
//                 Category ↓
//               </ViewMoreButton>

//               {/* Clear Filters */}
//               {(searchTerm || filterType) && (
//                 <ViewMoreButton
//                   className="filter-btn clear-btn"
//                   onClick={clearFilters}
//                   style={{ color: "#ff4444" }}
//                 >
//                   ✕ Clear
//                 </ViewMoreButton>
//               )}

//               <GreyfilterButton className="shortlistentry__filter_icon">
//                 <LuFilter />
//                 Filter
//               </GreyfilterButton>
//             </div>
//           </div>

//           {selectedButton === 0 && (
//             <>
//               <GlobalSecondTable
//                 data={data}
//                 columns={columns}
//                 selectedRows={selectedRows}
//                 onCheckboxChange={handleCheckboxChange}
//                 onRowClick={setSelectedRow}
//               />
//             </>
//           )}

//           {selectedButton === 1 && (
//             <>
//               <GlobalSecondTable
//                 data={data}
//                 columns={columns}
//                 selectedRows={selectedRows}
//                 onCheckboxChange={handleCheckboxChange}
//                 onRowClick={setSelectedRow}
//               />
//             </>
//           )}

//           <div className="shortlist_butt">
//             <GreyBorderButton onClick={() => navigate("/jury-round")}>
//               Back to Jury Rounds
//             </GreyBorderButton>
//             <RedBackgroundButton onClick={handleSubmit}>
//               Shortlist Selected Entry Form
//             </RedBackgroundButton>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };



import React, { useEffect, useState } from "react";
import { GreenContent, JuryRound, RedContent, RedMainHeading } from "../../../../Global/GlobalText";
import { IoSearchSharp } from "react-icons/io5";
import { LuFilter } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import "./ShortListEntryForm.scss";
import { CreateButton, GreyBorderButton, GreyfilterButton, RedBackgroundButton, ViewMoreButton } from "../../../../Global/GlobalButton";
import { GlobalSecondTable } from "../../../../Global/GlobalSecondTable/GlobalSecondTable";
import { TitleBar } from "../../../../Global/TitleBar/TitleBar";
import { TopBar } from "../../../TopBar/TopBar";
import axios from "axios";
import { EXCHNAGE_URL } from "../../../../../Url/Url";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { MdEditSquare } from "react-icons/md";
import { useLoading } from "../../../../LoadingContext";
import { FaHandPointer } from "react-icons/fa"; // 👈 Import hand icon

export const ShortListEntryForm = () => {
  const { setLoading } = useLoading();

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedButton, setSelectedButton] = useState(0);
  const eventIdGet = useSelector((state) => state?.users?.id);
  const [selectedRound, setSelectedRound] = useState(null);
  const [roundData, setRoundData] = useState([]);
  const [roundId, setRoundId] = useState(null);
  const [roundName, setRoundName] = useState("");
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const eventId = String(eventIdGet);
  const [loader, setLoader] = useState(false);
  const [selectedSubmissionIds, setSelectedSubmissionIds] = useState([]);
  const [shortlistedData, setShortlistedData] = useState([]);
  
  // Search and Filter states
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const getShortlistedData = async () => {
    setLoader(true);
    setLoading(true);
    try {
      const apiUrl = `${EXCHNAGE_URL}/getShortlist?eventId=${eventId}&is_shortlist=0`;
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-Type": "Application/json",
          authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        console.log(response, "sesssss");
        const subData = response.data.data;
        setShortlistedData(subData);
        setFilteredData(subData);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
      setLoading(false);
    }
  };

  const updatePaymentStatus = async (submissionId) => {
    setLoading(true);
    try {
      const response = await axios.put(
        `${EXCHNAGE_URL}/submission/payment-status`,
        { submissionId },
        {
          headers: { authorization: `Bearer ${token}` },
        }
      );
      if (response.data.success) {
        toast.success("Payment Updated");
        getShortlistedData();
      }
    } catch (error) {
      toast.error("Failed to update payment");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchRounds = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${EXCHNAGE_URL}/listOfRounds?eventId=${eventId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const roundData = response.data.data;
        setRoundData(roundData);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchRounds();
  }, [eventId, token]);

  useEffect(() => {
    getShortlistedData();
  }, [eventId]);

  // Filter and Search logic
  useEffect(() => {
    let result = [...shortlistedData];

    if (searchTerm.trim() !== "") {
      const searchLower = searchTerm.toLowerCase().trim();
      result = result.filter((submission) => {
        const title = submission.fields.find(field => field.field_name.startsWith("title"))?.field_value || "";
        const category = submission.fields.find(field => field.field_name.startsWith("category"))?.field_value || "";
        const submissionId = String(submission.submission_id || "");
        
        return (
          title.toLowerCase().includes(searchLower) ||
          category.toLowerCase().includes(searchLower) ||
          submissionId.includes(searchLower)
        );
      });
    }

    if (filterType) {
      result = [...result].sort((a, b) => {
        const getTitle = (item) => item.fields.find(field => field.field_name.startsWith("title"))?.field_value || "";
        const getCategory = (item) => item.fields.find(field => field.field_name.startsWith("category"))?.field_value || "";

        let aValue, bValue;
        switch (filterType) {
          case "title-asc":
            aValue = getTitle(a).toLowerCase();
            bValue = getTitle(b).toLowerCase();
            return aValue.localeCompare(bValue);
          case "title-desc":
            aValue = getTitle(a).toLowerCase();
            bValue = getTitle(b).toLowerCase();
            return bValue.localeCompare(aValue);
          case "category-asc":
            aValue = getCategory(a).toLowerCase();
            bValue = getCategory(b).toLowerCase();
            return aValue.localeCompare(bValue);
          case "category-desc":
            aValue = getCategory(a).toLowerCase();
            bValue = getCategory(b).toLowerCase();
            return bValue.localeCompare(aValue);
          default:
            return 0;
        }
      });
    }

    setFilteredData(result);
  }, [searchTerm, filterType, shortlistedData]);

  const handleRoundClick = (round) => {
    setSelectedRound(round);
    toast.success("Round selected Successfully");
    setRoundId(round.roundId);
    setRoundName(round.round_name);
    setIsDropdownVisible(false);
  };

  const handleCheckboxChangeTable = (rowId, checked) => {
    const selectedRow = filteredData.find((row) => row["Submission ID"] === rowId);
    console.log(selectedRow, "rowwwwww");
    if (checked) {
      setSelectedData((prevSelectedData) => [
        ...prevSelectedData,
        selectedRow["Submission ID"],
      ]);
    } else {
      setSelectedData((prevSelectedData) =>
        prevSelectedData.filter((id) => id !== selectedRow["Submission ID"])
      );
    }

    if (checked) {
      setSelectedRows((prevSelectedRows) => [...prevSelectedRows, rowId]);
    } else {
      setSelectedRows((prevSelectedRows) =>
        prevSelectedRows.filter((id) => id !== rowId)
      );
    }
  };

  console.log(shortlistedData, "daaaatatatat");
  
  const columns = [
    { label: "Submission ID", accessor: "Submission ID" },
    { label: "Category", accessor: "Category" },
    { label: "Title", accessor: "Title" },
    { label: "Overall Score", accessor: "Overall Score" },
    { label: "Payment Status", accessor: "Payment Status" },
    { label: "Action", accessor: "Action" },
  ];

  const data = filteredData
    .filter(submission => submission && submission.fields)
    .map((submission) => {
      const title = submission.fields.find(field => field.field_name.startsWith("title"))?.field_value || "";
      const category = submission.fields.find(field => field.field_name.startsWith("category"))?.field_value || "";
      const paymentStatus = submission.payment_status;

      console.log(paymentStatus, "paymentStatus");
      return {
        rowId: submission.submission_id,
        "Submission ID": submission.submission_id,
        Category: category,
        Title: title,
        "Overall Score": submission.score !== null ? submission.score : "",
        "Payment Status": paymentStatus,
        Action: paymentStatus?.toLowerCase() !== "paid" ? (
          <button
            onClick={() => updatePaymentStatus(submission.submission_id)}
            style={{
              background: "#16a34a",
              color: "#fff",
              border: "none",
              padding: "8px 14px",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "600",
              fontSize: "13px",
              transition: "0.3s",
            }}
          >
            ✓ Mark as Paid
          </button>
        ) : (
          <span
            style={{
              background: "#dcfce7",
              color: "#15803d",
              padding: "8px 14px",
              borderRadius: "8px",
              fontWeight: "600",
              display: "inline-block",
            }}
          >
            ✓ Paid
          </span>
        ),
      };
    });

  console.log(data, "daadadaada");

  const handleCheckboxChange = (rowId, checked) => {
    const selectedRow = filteredData.find((row) => row["Submission ID"] === rowId);

    if (checked) {
      setSelectedData((prevSelectedData) => [...prevSelectedData, rowId]);
    } else {
      setSelectedData((prevSelectedData) =>
        prevSelectedData.filter((id) => id !== rowId)
      );
    }

    if (checked) {
      setSelectedRows((prevSelectedRows) => [...prevSelectedRows, rowId]);
    } else {
      setSelectedRows((prevSelectedRows) =>
        prevSelectedRows.filter((id) => id !== rowId)
      );
    }
  };

  const setSelectedRow = (row) => {
    console.log("Selected row:", row);
  };

  // ✅ UPDATED: Only select PAID submissions
  const handleSelectAllPaid = () => {
    // Get only paid submissions from current filtered data
    const paidSubmissions = data.filter(row => 
      row["Payment Status"]?.toLowerCase() === "paid"
    );
    
    const paidRowIds = paidSubmissions.map(row => row.rowId);
    
    // Only select if there are paid submissions
    if (paidRowIds.length === 0) {
      toast.info("No paid submissions available to select");
      return;
    }
    
    setSelectedRows(paidRowIds);
    setSelectedData(paidRowIds);
    setSelectedButton(0);
    toast.success(`Selected ${paidRowIds.length} paid submissions`);
  };

  // ✅ UPDATED: Deselect all
  const handleDeselectAll = () => {
    setSelectedRows([]);
    setSelectedData([]);
    setSelectedButton(1);
  };

  const handleSubmit = async () => {
    if (!roundId) {
      toast.error("Please Select a round.");
      return;
    }
    if (selectedData.length === 0) {
      toast.error('Please select at least one submission.');
      return;
    }
    setLoading(true);
    try {
      const payload = {
        eventId: eventId,
        roundId: roundId,
        submission_ids: selectedData,
        shortlist_round: roundName,
      };

      const response = await axios.post(`${EXCHNAGE_URL}/shortlist`, payload, {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response.status === 200) {
        toast.success('Shortlist submitted successfully');
        getShortlistedData();
        setSelectedRows([]);
        setSelectedData([]);
      }
    } catch (error) {
      console.error(error);
      toast.error('Error submitting shortlist');
    } finally {
      setLoading(false);
    }
  };

  const handleFilterClick = (type) => {
    if (filterType === type) {
      setFilterType("");
    } else {
      setFilterType(type);
    }
  };

  const clearFilters = () => {
    setSearchTerm("");
    setFilterType("");
  };

  return (
    <div>
      <div className="shortlistentry_data_div">
        <TitleBar title="Jury Round" />
        <div className="shortlistentry_data_white_bg">
          <TopBar titleheading="Shortlist Entry Form for Round 1" />
          <div className="newBtn">
            <div>
              <button className="Bt" onClick={() => setIsDropdownVisible(!isDropdownVisible)}>
                {isDropdownVisible ? 'Hide Rounds' : 'Show Rounds'}
              </button>
              {isDropdownVisible && (
                <div className={`dropdown-container ${isDropdownVisible ? "show" : ""}`}>
                  {roundData.length !== 0 ? (
                    roundData.map((round, index) => (
                      <div key={round.roundId} className="round-button-container" style={{ marginBottom: '1rem' }}>
                        <CreateButton className="Btt" onClick={() => handleRoundClick(round)}>
                          {round.round_name}
                        </CreateButton>
                        {round.is_active === 1 ? (
                          <GreenContent>Active</GreenContent>
                        ) : (
                          <RedContent>Unactive</RedContent>
                        )}
                      </div>
                    ))
                  ) : (
                    <div>No rounds available</div>
                  )}
                </div>
              )}
            </div>
            {selectedRound && (
              <div className="round-details">
                <CreateButton>{selectedRound.round_name}</CreateButton>
              </div>
            )}
          </div>

          <div className="shortlistentry_submission_div">
            {/* ✅ UPDATED: Select All Paid Submissions with Hand Icon */}
            <div
              className="shortlistentry_sub_submission"
              style={{ 
                backgroundColor: selectedButton === 0 ? "#FFE2E5" : "#F6F8F9",
                cursor: "pointer",
                position: "relative"
              }}
              onClick={handleSelectAllPaid}
            >
              <RedMainHeading style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <FaHandPointer style={{ color: "#dc2626", fontSize: "18px" }} />
                Viewing: {data.length} submissions
              </RedMainHeading>
              <JuryRound style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <FaHandPointer style={{ color: "#6b7280", fontSize: "14px" }} />
                Select only PAID submissions
              </JuryRound>
            </div>

            {/* ✅ UPDATED: Deselect All */}
            <div
              className="shortlistentry_sub_submission"
              style={{ 
                backgroundColor: selectedButton === 1 ? "#FFE2E5" : "#F6F8F9",
                cursor: "pointer"
              }}
              onClick={handleDeselectAll}
            >
              <RedMainHeading>Selected: {selectedRows.length} submissions</RedMainHeading>
              <JuryRound>Deselect all selected submissions</JuryRound>
            </div>
          </div>

          <div className="shortlistentry__table_div">
            <div className="shortlistentry__table_search">
              <div className="shortlistentry__table_icon">
                <IoSearchSharp />
              </div>
              <div className="shortlistentry__table_icon_content">
                <input
                  type="text"
                  placeholder="Search by Title, Category or Submission ID..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            <div className="shortlistentry__filter_buttons">
              <ViewMoreButton
                className={`filter-btn ${filterType === "title-asc" ? "active" : ""}`}
                onClick={() => handleFilterClick("title-asc")}
                title="Sort Title A-Z"
              >
                Title ↑
              </ViewMoreButton>
              <ViewMoreButton
                className={`filter-btn ${filterType === "title-desc" ? "active" : ""}`}
                onClick={() => handleFilterClick("title-desc")}
                title="Sort Title Z-A"
              >
                Title ↓
              </ViewMoreButton>

              <ViewMoreButton
                className={`filter-btn ${filterType === "category-asc" ? "active" : ""}`}
                onClick={() => handleFilterClick("category-asc")}
                title="Sort Category A-Z"
              >
                Category ↑
              </ViewMoreButton>
              <ViewMoreButton
                className={`filter-btn ${filterType === "category-desc" ? "active" : ""}`}
                onClick={() => handleFilterClick("category-desc")}
                title="Sort Category Z-A"
              >
                Category ↓
              </ViewMoreButton>

              {(searchTerm || filterType) && (
                <ViewMoreButton
                  className="filter-btn clear-btn"
                  onClick={clearFilters}
                  style={{ color: "#ff4444" }}
                >
                  ✕ Clear
                </ViewMoreButton>
              )}

              <GreyfilterButton className="shortlistentry__filter_icon">
                <LuFilter />
                Filter
              </GreyfilterButton>
            </div>
          </div>

          {selectedButton === 0 && (
            <>
              <GlobalSecondTable
                data={data}
                columns={columns}
                selectedRows={selectedRows}
                onCheckboxChange={handleCheckboxChange}
                onRowClick={setSelectedRow}
              />
            </>
          )}

          {selectedButton === 1 && (
            <>
              <GlobalSecondTable
                data={data}
                columns={columns}
                selectedRows={selectedRows}
                onCheckboxChange={handleCheckboxChange}
                onRowClick={setSelectedRow}
              />
            </>
          )}

          <div className="shortlist_butt">
            <GreyBorderButton onClick={() => navigate("/jury-round")}>
              Back to Jury Rounds
            </GreyBorderButton>
            <RedBackgroundButton onClick={handleSubmit}>
              Shortlist Selected Entry Form
            </RedBackgroundButton>
          </div>
        </div>
      </div>
    </div>
  );
};